"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
require("../../styles/components/notification.less");
const CloseButton = () => react_1.default.createElement("span", { className: "toast-close-button" });
const Zoom = (0, react_toastify_1.cssTransition)({
    enter: 'zoomIn',
    exit: 'zoomOut',
    duration: [400, 400],
});
const Notification = () => (react_1.default.createElement(react_toastify_1.ToastContainer, { position: react_toastify_1.toast.POSITION.BOTTOM_CENTER, className: "toast-notification-container", toastClassName: "toast-notification", closeButton: react_1.default.createElement(CloseButton, null), hideProgressBar: true, newestOnTop: true, closeOnClick: true, rtl: false, transition: Zoom, draggable: true, pauseOnHover: true }));
// pauseOnVisibilityChange
// enableMultiContainer
exports.default = Notification;
//# sourceMappingURL=notification.js.map